import { Trans, useTranslation } from 'react-i18next';
import environment from '@environment';

/**
 * Translations for managing a recurring payment.
 */
const useManageTranslations = () => {
  const { t } = useTranslation();

  const key = (translationKey: string) => `account.recurringPayment.manage.${translationKey}`;
  const manage = (translationKey: string) => t(key(translationKey));

  const changeCardHeadsUp = (amount: string) => {
    return (<Trans
      i18nKey={key('changeCardHeadsUp')}
      defaults="Just a heads up: when you update your card, a small amount of {{amount}} might be temporarily deducted for verification purposes."
      values={{ amount }}
    />);
  }

  return {
    heading: manage('heading'),
    text: manage('text'),
    details: {
      heading: manage('details.heading'),
      text: manage('details.text'),
    },
    updateOrChange: manage('updateOrChange'),
    changeCard: manage('changeCard'),
    changeCardHeadsUp: changeCardHeadsUp,
    cancelRecurringPayment: manage('cancelRecurringPayment'),
    cardNumber: manage('cardNumber'),
    expiryDate: manage('expiryDate'),
  };
}

export default useManageTranslations;